export const SET_TIKTOKSHOP_UI_FLAG = 'SET_TIKTOKSHOP_UI_FLAG';
export const GET_COUPONS = 'GET_COUPONS';
export const GET_ORDERS = 'GET_ORDERS';
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';
export const SEND_ORDER_MESSAGE = 'SEND_ORDER_MESSAGE';
export const SEND_PRODUCT_MESSAGE = 'SEND_PRODUCT_MESSAGE';
